module.exports = __webpack_public_path__ + "staticcomp/img/content_1.c26d025.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/2/content_1.jpg
// module id = EMGS
// module chunks = 39